import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Card from './card';
import CardContainer from 'bundles/apex/card/container';
import ContactRoleGroups from 'bundles/backoffice/contacts/grouped_roles';
import { extractRelationshipGroup, getRelationshipsInGroups } from 'bundles/backoffice/contacts/panel/helpers';

export function Contacts({ availableRelationships, fields, dealType }) {
  const relationshipGroups = [];
  const relationships = [...availableRelationships];

  if (dealType === 'sale') {
    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'seller',
      title: 'Seller',
      values: ['seller', 'seller_contact']
    }));

    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'buyer',
      title: 'Buyer',
      values: ['buyer', 'buyer_contact']
    }));
  } else if (dealType === 'buyer_rep') {
    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'buyer',
      title: 'Buyer',
      values: ['buyer', 'buyer_contact', 'client']
    }));

    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'seller',
      title: 'Seller',
      values: ['seller', 'seller_contact']
    }));
  } else if (dealType === 'lease') {
    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'owner',
      title: 'Owner',
      values: ['owner_landlord', 'owner_representative', 'owner_user']
    }));

    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'tenant',
      title: 'Tenant',
      values: ['tenant', 'tenant_contact']
    }));
  } else if (dealType === 'tenant_rep') {
    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'tenant',
      title: 'Tenant',
      values: ['tenant', 'tenant_contact', 'client']
    }));

    relationshipGroups.push(extractRelationshipGroup(relationships, {
      contactLabel: 'owner',
      title: 'Owner/Landlord',
      values: ['owner_landlord', 'owner_representative', 'owner_user']
    }));
  }

  relationshipGroups.forEach((group) => {
    group.required = fields[group.contactLabel] && fields[group.contactLabel].required;
  });

  relationshipGroups.push({
    availableRelationships: relationships,
    showAllExcept: [...getRelationshipsInGroups(relationshipGroups), 'payer'],
    title: 'Other Deal Contacts'
  });

  return <React.Fragment>
    <CardContainer>
      <ContactRoleGroups groupComponent={Card} relationshipGroups={relationshipGroups} />
    </CardContainer>
  </React.Fragment>;
}

Contacts.propTypes = {
  availableRelationships: PropTypes.array.isRequired,
  dealType: PropTypes.string,
  fields: PropTypes.object,
};

const mapStateToProps = ({ deal, fields, options }) => {
  return {
    availableRelationships: options.availableContactRelationships,
    dealType: deal.dealType,
    fields,
  };
};

export default connect(mapStateToProps)(Contacts);
